import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Breakpoint } from "@mui/material";

interface Props {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
  onConfirm: () => void;
  onClose?: () => void;
  Component: React.ReactElement<any>;
  title: string;
  text?: string;
  confirmText: string;
  cancelText: string;
  body?: React.ReactElement<any>;
  maxWidth?: Breakpoint;
}

export default function SimpleModal({
  open,
  setOpen,
  onConfirm,
  onClose = () => {},
  Component,
  title,
  text,
  confirmText,
  cancelText,
  body,
  maxWidth,
}: Props) {
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    onClose();
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <React.Fragment>
      {React.cloneElement(Component, { onClick: handleClickOpen })}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={maxWidth ?? "sm"}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text ?? <></>}
          </DialogContentText>
          {body}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancelText}</Button>
          <Button onClick={handleConfirm} autoFocus>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
